<template>
  <el-dialog title="设置内容" :visible.sync="show" width="400px" center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="!loading">
    <div class="flex-box">
      <span class="pt5">事项说明：</span>
      <div class="flex-1">
        <section class="w100 mb10 flex-box" v-for="(item, index) in itemArr" :key="index">
          <el-input class="mr10" v-model="itemArr[index]" placeholder="请输入内容"></el-input>
          <el-button v-if="index == 0" plain icon="myfont icon-tainjia" size="mini" key="icon" @click="changeItemArr(null)"></el-button>
          <el-button v-else plain icon="myfont icon-shanjian" size="mini" key="icon" @click="changeItemArr(index)"></el-button>
        </section>
      </div>
    </div>

    <div class="mt10 flex-box al-c">
      <span>是否假期：</span>
      <div class="flex-1">
        <el-radio v-model="isvacation" :label="null">正常作息</el-radio>
        <el-radio v-model="isvacation" :label="'1'">休假</el-radio>
        <el-radio v-model="isvacation" :label="'2'">上班</el-radio>
      </div>
    </div>

    <div slot="footer">
      <p class="mb10 font-12 w100 tx-c red" v-show="!isEdit">温馨提示：批量添加只能在原有的事件中插入新事件，如需修改事件请点击当天右上角的 <i class="blue myfont icon-bianji"></i> 按钮进行编辑。</p>
      <el-button type="primary" @click="updata" :loading="loading">{{ isEdit ? '修改' : '批量添加' }}</el-button>
      <el-button @click="show = false" :loading="loading">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "CalendarDialog",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      show: false,

      //
      isEdit: false,
      idArr: [],
      dateArr: [],
      itemArr: [],
      // null：正常， 1：休假， 2：上班
      isvacation: null
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    addDate() {
      let obj = {};
      obj.ids = this.idArr.join(",");
      obj.datestr = this.dateArr.join(",");
      obj.isvacation = this.isvacation;
      let itemStr = [];
      for (const item of this.itemArr) {
        if (item) {
          itemStr.push(item);
        }
      }
      obj.item = itemStr.join("&split&");

      this.loading = true;
      this.$http
        .post("/calendar/batcheSaveTag", JSON.stringify(obj), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.$message.success(data.resMsg);

            this.show = false;
            this.$nextTick(() => {
              this.$emit("init-page");
            });
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    editDate() {
      let obj = {};
      obj.wid = this.idArr[0] == "*" ? "" : this.idArr[0];
      obj.currentdate = this.dateArr[0];
      obj.isvacation = this.isvacation;
      let itemStr = [];
      for (const item of this.itemArr) {
        if (item) {
          itemStr.push(item);
        }
      }
      obj.item = itemStr.join("&split&");

      this.loading = true;
      this.$http
        .post("/calendar/saveTag", JSON.stringify(obj), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.$message.success(data.resMsg);

            this.show = false;
            this.$nextTick(() => {
              this.$emit("init-page");
            });
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    updata() {
      if (this.isEdit) {
        // 修改
        this.editDate();
      } else {
        // 批量
        this.addDate();
      }
    },
    showView(idArr, dateArr, itemArr, isvacation, isEdit) {
      this.idArr = idArr;
      this.dateArr = dateArr;
      this.itemArr = [...itemArr];
      this.isvacation = isvacation;
      this.isEdit = isEdit;

      this.$nextTick(() => {
        this.show = true;
      });
    },
    changeItemArr(index) {
      if (index) {
        this.itemArr.splice(index, 1);
      } else {
        this.itemArr.push("");
      }
    }
  }
};
</script>

<style scoped>
</style>
